import axios from 'axios';
import AxiosWrapper from "../../../basecomp/base/AxiosWrapper";
const { axiosGetCallWithToken, axiosPutCallWithToken, axiosPostCallWithToken, axiosDeleteCallWithToken } = AxiosWrapper;

const convertToDbName = (name) => {
    return name.replace(/\s+/g, '_');
};

export const fetchAllDatabases = async () => {
    const response = await axiosGetCallWithToken(`/devtool/getAllDatabase`);
    return response;
};

export const fetchDatabaseTables = async (databaseName) => {
    const dbName = convertToDbName(databaseName);
    const response = await axiosGetCallWithToken(
        `/devtool/getTables?database=${encodeURIComponent(dbName)}`
    );
    return response;
};

export const fetchTableData = async (databaseName, tableName, page = 1, limit = 100, filters = {}) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);

    let queryParams = `database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}&page=${page}&limit=${limit}`;

    if (filters.searchQuery) {
        queryParams += `&search=${encodeURIComponent(filters.searchQuery)}`;
    }
    if (filters.filterColumn && filters.filterValue) {
        queryParams += `&filterColumn=${encodeURIComponent(filters.filterColumn)}&filterValue=${encodeURIComponent(filters.filterValue)}`;
    }
    if (filters.sortColumn) {
        queryParams += `&sortColumn=${encodeURIComponent(filters.sortColumn)}&sortDirection=${filters.sortDirection || 'ASC'}`;
    }

    const response = await axiosGetCallWithToken(`/devtool/getTableData?${queryParams}`);
    return response;
};

export const insertTableRow = async (databaseName, tableName, rowData) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);

    const requestBody = {
        database: dbName,
        tableName: tableDbName,
        data: rowData 
    };

    const response = await axiosPostCallWithToken(
        `/devtool/insertRow`,
        requestBody
    );
    return response;
};

export const updateTableRow = async (databaseName, tableName, rowId, rowData) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosPutCallWithToken(
        `/devtool/updateRow?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}&rowId=${rowId}`,
        rowData
    );
    return response;
};

export const deleteTableRow = async (databaseName, tableName, rowIds) => {
    const idsArray = Array.isArray(rowIds) ? rowIds : [rowIds];
    
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    
    const rowIdString = idsArray.join(',');
    
    const response = await axiosDeleteCallWithToken(
        `/devtool/deleteRow?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}&rowId=${encodeURIComponent(rowIdString)}`
    );
    return response;
};

export const truncateTable = async (databaseName, tableName) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosDeleteCallWithToken(
        `/devtool/truncateTable?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}`
    );
    return response;
};

export const dropTable = async (databaseName, tableName) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosDeleteCallWithToken(
        `/devtool/dropTable?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}`
    );
    return response;
};

export const addTableColumn = async (databaseName, tableName, columnData) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosPostCallWithToken(
        `/devtool/addColumn?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}`,
        columnData
    );
    return response;
};

export const modifyTableColumn = async (databaseName, tableName, columnName, columnData) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosPutCallWithToken(
        `/devtool/modifyColumn?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}&columnName=${encodeURIComponent(columnName)}`,
        columnData
    );
    return response;
};

export const deleteTableColumn = async (databaseName, tableName, columnName) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosDeleteCallWithToken(
        `/devtool/deleteColumn?database=${encodeURIComponent(dbName)}&tableName=${encodeURIComponent(tableDbName)}&columnName=${encodeURIComponent(columnName)}`
    );
    return response;
};

export const exportTableData = async (database, tableName, format, filters, config = {}) => {
    try {
        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Authentication token not found. Please login again.');
        }

        const params = new URLSearchParams({
            database,
            tableName,
            format,
            ...(filters.searchQuery && { search: filters.searchQuery }),
            ...(filters.filterColumn && { filterColumn: filters.filterColumn }),
            ...(filters.filterValue && { filterValue: filters.filterValue })
        });

        const response = await axios.get(
            `https://uatapi.conasservices.com/1.0.1/devtool/exportTable?${params.toString()}`,
            {
                ...config,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': token,
                }
            }
        );

        return response;
    } catch (error) {
        console.error('API Error:', error);
        throw error;
    }
};

export const importTableData = async (databaseName, tableName, file, options = {}) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('database', dbName);
    formData.append('tableName', tableDbName);
    formData.append('options', JSON.stringify(options));

    const response = await axiosPostCallWithToken('/devtool/importTable', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response;
};

export const createTable = async (databaseName, tableName, columnData) => {
    const dbName = convertToDbName(databaseName);
    const tableDbName = convertToDbName(tableName);
    const response = await axiosPostCallWithToken(
        `/devtool/createTable?database=${encodeURIComponent(dbName)}`,
        {
            tableName: tableDbName,
            columns: columnData
        }
    );
    return response;
};

export const executeCustomQueryWithFilter = async (databaseName, query) => {
    const dbName = convertToDbName(databaseName);
    const response = await axiosPostCallWithToken(
        `/devtool/executeQueryWithFilter?database=${encodeURIComponent(dbName)}`,
        { query }
    );
    return response;
};